import axios from "axios";
import React, { useEffect, useState } from "react";
import { GET_DASHBOARD_DATA, GET_SHOPS } from "../routes";
import Select from "react-select";

const Dashboard = () => {
  const [loggedInUser, setLoggedInUser] = useState();

  const [loading, setLoading] = useState(true);

  const [dashboardData, setDashboardData] = useState(null);
  const [staticDashboardData, setStaticDashboardData] = useState(null);
  const [selectedStore, setSelectedStore] = useState(null);

  const [shops, setShops] = useState([]);

  const getDashboardData = async () => {
    setLoading(true);
    let res = await axios.post(GET_DASHBOARD_DATA);
    setStaticDashboardData({
      activeShops: res.data.activeShops,
      cashbackStore: res.data.cashbackStore,
      pointStore: res.data.pointStore,
      inActiveShops: res.data.inActiveShops,
      freePlanMerchant: res.data.freePlanMerchant,
      basicPlanMerchant: res.data.basicPlanMerchant,
      mediumPlanMerchant: res.data.mediumPlanMerchant,
      advancePlanMerchant: res.data.advancePlanMerchant,
      customPlanMerchant: res.data.customPlanMerchant,
      shop_money_format: res.data.shop_money_format,
      reward_title: res.data.reward_title,
    });
    setDashboardData(res.data);
    setLoading(false);
  };

  const options = [{ value: "", label: "Select Store" }];

  const getShops = async () => {
    const result = await axios.post(GET_SHOPS, { all: true });
    setShops(result.data);
  };

  shops &&
    shops.map((value) =>
      options.push({
        value: value.id,
        label: value.shop,
      })
    );

  const getSelectedStore = async (event) => {
    if (!event) return;

    if (selectedStore?.value === event.value) {
      return;
    }

    setSelectedStore(event);
    setDashboardData(null);
    let res = await axios.post(GET_DASHBOARD_DATA, { shop_id: event.value });
    setDashboardData(res.data);
  };

  useEffect(() => {
    let user = localStorage.getItem("user");
    setLoggedInUser(JSON.parse(user));
    getDashboardData();
    getShops();
  }, []);

  return (
    <>
      <div className="container mt-3">
        <div
          className="row"
          style={{ border: "1px solid 1px solid #80808063", padding: "12px 0" }}
        >
          <div className="col-md-3">
            <div className="dashboard-card">
              <h5><i className="fa-solid fa-store" style={{ fontSize: "medium" }}></i>&nbsp;Active Stores</h5>
              <div>
                {staticDashboardData != null ? (
                  <span
                    style={{
                      color: 'rgb(28, 230, 92)',
                      fontWeight: "600"
                    }}
                  >
                  {staticDashboardData?.activeShops}
                </span>
                ) : (
                  <div
                    id="loader"
                    style={{ height: "18px", width: "18px" }}
                  ></div>
                )}
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="dashboard-card">
              <h5><i className="fa-solid fa-store-slash" style={{ fontSize: "medium" }}></i>&nbsp;In-Active Stores</h5>
              <div>
                {staticDashboardData != null ? (
                  <span
                    style={{
                      color: '#f66464',
                      fontWeight: "600"
                    }}
                  >
                    {staticDashboardData?.inActiveShops}
                  </span>
                ) : (
                  <div
                    id="loader"
                    style={{ height: "18px", width: "18px" }}
                  ></div>
                )}
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="dashboard-card">
              <h5><i className="fa-solid fa-coins" style={{ fontSize: "medium" }}></i>&nbsp;Points Stores</h5>
              <div>
                {staticDashboardData != null ? (
                  <span
                    style={{
                      color: '#4F46E5',
                      fontWeight: "600"
                    }}
                  >
                    {staticDashboardData?.pointStore}
                  </span>
                ) : (
                  <div
                    id="loader"
                    style={{ height: "18px", width: "18px" }}
                  ></div>
                )}
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="dashboard-card">
              <h5><i className="fa-solid fa-money-bill-wave" style={{ fontSize: "medium" }}></i>&nbsp;Cashback Stores</h5>
              <div>
                {staticDashboardData != null ? (
                  <span
                    style={{
                      color: '#059669',
                      fontWeight: "600"
                    }}
                  >
                    {staticDashboardData?.cashbackStore}
                  </span>
                ) : (
                  <div
                    id="loader"
                    style={{ height: "18px", width: "18px" }}
                  ></div>
                )}
              </div>
            </div>
          </div>
          
        </div>
        <div
          className="row"
          style={{ border: "1px solid 1px solid #80808063", padding: "12px 0" }}
        >
          <div className="col-md-3">
            <div className="dashboard-card">
              <h5><i className="fa-solid fa-gift" style={{ fontSize: "medium" }}></i>&nbsp;Free Plan Merchants</h5>
              <div>
                {staticDashboardData != null ? (
                  staticDashboardData?.freePlanMerchant
                ) : (
                  <div
                    id="loader"
                    style={{ height: "18px", width: "18px" }}
                  ></div>
                )}
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="dashboard-card">
              <h5><i className="fa-solid fa-file-lines" style={{ fontSize: "medium" }}></i>&nbsp;Basic Plan Merchants</h5>
              <div>
                {staticDashboardData != null ? (
                  staticDashboardData?.basicPlanMerchant
                ) : (
                  <div
                    id="loader"
                    style={{ height: "18px", width: "18px" }}
                  ></div>
                )}
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="dashboard-card">
              <h5><i className="fa-solid fa-chart-simple" style={{ fontSize: "medium" }}></i>&nbsp;Medium Plan Merchants</h5>
              <div>
                {staticDashboardData != null ? (
                  staticDashboardData?.mediumPlanMerchant
                ) : (
                  <div
                    id="loader"
                    style={{ height: "18px", width: "18px" }}
                  ></div>
                )}
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="dashboard-card">
              <h5><i className="fa-solid fa-rocket" style={{ fontSize: "medium" }}></i>&nbsp;Advance Plan Merchants</h5>
              <div>
                {staticDashboardData != null ? (
                  staticDashboardData?.advancePlanMerchant
                ) : (
                  <div
                    id="loader"
                    style={{ height: "18px", width: "18px" }}
                  ></div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div
          className="row"
          style={{ border: "1px solid 1px solid #80808063", padding: "12px 0" }}
        >

          <div className="col-md-3">
            <div className="dashboard-card">
              <h5><i className="fa-solid fa-sliders" style={{ fontSize: "medium" }}></i>&nbsp;Custom Plan Merchants</h5>
              <div>
                {staticDashboardData != null ? (
                  staticDashboardData?.customPlanMerchant
                ) : (
                  <div
                    id="loader"
                    style={{ height: "18px", width: "18px" }}
                  ></div>
                )}
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div className="row my-3">
          <div className="col-md-4">
            {shops.length ? (
              <Select
                label="Select Store"
                value={selectedStore}
                options={options}
                onChange={(e) => getSelectedStore(e)}
              />
            ) : (
              <div id="loader" style={{ height: "25px", width: "25px" }}></div>
            )}
          </div>
        </div>
        <div
          className="row"
          style={{ border: "1px solid 1px solid #80808063", padding: "12px 0" }}
        >
          <span
            style={{
              color: '#4F46E5',
              fontWeight: "600"
            }}
          >
            {dashboardData != null && dashboardData?.reward_type != null ? dashboardData?.reward_type : null }
          </span>
          <div className="col-md-3">
            <div className="dashboard-card">
              <h5><i className="fa-solid fa-trophy" style={{ fontSize: "medium" }}></i>&nbsp;Total Rewards</h5>
              <div>
                {dashboardData != null ? (
                  dashboardData?.totalCashback
                ) : (
                  <div
                    id="loader"
                    style={{ height: "18px", width: "18px" }}
                  ></div>
                )}
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="dashboard-card">
              <h5><i className="fa-solid fa-money-bill-transfer" style={{ fontSize: "medium" }}></i>&nbsp;Redeemed Rewards</h5>
              <div>
                {dashboardData != null ? (
                  dashboardData?.redeemedCashback
                ) : (
                  <div
                    id="loader"
                    style={{ height: "18px", width: "18px" }}
                  ></div>
                )}
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="dashboard-card">
              <h5><i className="fa-solid fa-hourglass-half" style={{ fontSize: "medium" }}></i>&nbsp;Pending Rewards</h5>
              <div>
                {dashboardData != null ? (
                  dashboardData?.totalPendingCashback
                ) : (
                  <div
                    id="loader"
                    style={{ height: "18px", width: "18px" }}
                  ></div>
                )}
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="dashboard-card">
              <h5><i className="fa-solid fa-bullhorn" style={{ fontSize: "medium" }}></i>&nbsp;Offer Campaigns</h5>
              <div>
                {dashboardData != null ? (
                  dashboardData?.totalCampaigns
                ) : (
                  <div
                    id="loader"
                    style={{ height: "18px", width: "18px" }}
                  ></div>
                )}
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </>
  );
};

export default Dashboard;
